import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ActivityPanelComponent } from '../../../../Common/Activity/activityPanel.component';
import { IWeissmanModalComponent } from '../../../../Compliance/WeissmanModalService';
import { ModalWrapperComponent } from '../../../../UI-Lib/Modal-Wrapper/modalWrapper.component';

export interface ParcelActivityModalParams {
    parcelId: number;
    siteId: number;
    years: number[];
}

@Component({
    selector: 'parcel-activity',
    templateUrl: 'parcelActivity.component.html',
    imports: [ModalWrapperComponent, ActivityPanelComponent],
})
export class ParcelActivityComponent implements IWeissmanModalComponent<ParcelActivityModalParams, void> {
    constructor(private readonly _bsModalRef: BsModalRef) {}

    params: ParcelActivityModalParams;
    result: void;

    close(): void {
        this._bsModalRef.hide();
    }
}
